// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgExpand24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M20.5 5.5C20.5 5.08579 20.1642 4.75 19.75 4.75C19.3358 4.75 19 5.08579 19 5.5V19.5C19 19.9142 19.3358 20.25 19.75 20.25C20.1642 20.25 20.5 19.9142 20.5 19.5V5.5ZM12.5303 6.46967C12.2374 6.17678 11.7626 6.17678 11.4697 6.46967L11.3971 6.55379C11.1792 6.8474 11.2034 7.26406 11.4697 7.53033L15.189 11.25H4.5C4.08579 11.25 3.75 11.5858 3.75 12C3.75 12.4142 4.08579 12.75 4.5 12.75H15.189L11.4697 16.4697C11.2034 16.7359 11.1792 17.1526 11.3971 17.4462L11.4697 17.5303C11.7626 17.8232 12.2374 17.8232 12.5303 17.5303L17.5303 12.5303C17.8232 12.2374 17.8232 11.7626 17.5303 11.4697L12.5303 6.46967Z"
				/>
			</Svg>
		);
	}
);
SvgExpand24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgExpand24;
